import classNames from 'classnames';
import { type FC, Fragment } from 'react';

import s from './ShortcutKeys.module.scss';

// Platform detection utility
const getPlatformModifier = (): string => {
  if (typeof navigator === 'undefined') return '⌘';

  const platform = navigator.userAgent?.toLowerCase() || '';

  switch (true) {
    case platform.includes('mac') || platform.includes('iphone') || platform.includes('ipad'):
      return '⌘'; // Command key for macOS/iOS
    case platform.includes('win'):
    case platform.includes('linux'):
      return 'Ctrl'; // Control key for Windows/Linux
    default:
      return '⌘'; // Default to command key
  }
};

// Helper function to replace $mod with platform-specific modifier
const replaceModifier = (value: string): string => {
  const modifier = getPlatformModifier();
  return value.replace(/\$mod/gi, modifier);
};

const ShortcutKeys: FC<{ value: string; isWhite?: boolean; uppercase?: boolean }> = ({
  value,
  isWhite,
  uppercase = true,
}) => {
  const processedValue = replaceModifier(value);

  return (
    <div className={s.wrapper}>
      {(processedValue.includes(' ') && (
        <>
          {processedValue.split(' ').map((part, i) => (
            <Fragment key={`${part}-${i}`}>
              <kbd className={classNames(s.key, isWhite ? s.keyWhite : s.keyDefault, !uppercase && s.noUppercase)}>
                {part}
              </kbd>
              {part && i < processedValue.split(' ').length - 1 && 'then'}
            </Fragment>
          ))}
        </>
      )) ||
        (processedValue.includes('+') && (
          <>
            {processedValue.split('+').map((part, i) => (
              <Fragment key={`${part}-${i}`}>
                <kbd className={classNames(s.key, isWhite ? s.keyWhite : s.keyDefault, !uppercase && s.noUppercase)}>
                  {part}
                </kbd>
              </Fragment>
            ))}
          </>
        )) || (
          <kbd className={classNames(s.key, isWhite ? s.keyWhite : s.keyDefault, !uppercase && s.noUppercase)}>
            {processedValue}
          </kbd>
        )}
    </div>
  );
};

export default ShortcutKeys;
